export interface Job {
    title: string;
    company: string;
    description: string;
    startDate: string;
    endDate: string;
}

export const jobs: Job[] = [
    {
        title: "Junior Software Developer",
        company: "CHECK24 Vergleichsportal Profis GmbH, Berlin",
        description: "Contribution to a web application based on Symfony (PHP) and React (JavaScript).",
        startDate: "Jan 2025",
        endDate: "June 2025",
    },
    {
        title: "Unity Game Developer (working student)",
        company: "Honig Studios GmbH, Berlin",
        description: "Development of an RPG deckbuilding game.",
        startDate: "April 2023",
        endDate: "Dec 2024",
    },
    {
        title: "Unity AR Developer (working student)",
        company: "tecVenture GmbH, Leipzig",
        description: "Development of an augmented reality application for the use in the medical field. \n Development of an embedded system for the construction industry.",
        startDate: "Sep 2020",
        endDate: "Dec 2022",
    },
    {
        title: "Gap Year (FSJ)",
        company: "Café Impuls, Berlin",
        description: "Organisation and management of events. \n Work with children and young people. \n Gastronomy and catering.",
        startDate: "Sep 2016",
        endDate: "Aug 2017",
    },
];
